import './SelectableList.css';

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@mui/material';
import { ExpandMore, ExpandLess, CheckBox, CheckBoxOutlineBlank, DoneAll, RemoveDone } from '@mui/icons-material';
import { generateClassName } from './helpers';
import useB2BTranslation from './hooks/useB2BTranslation';

const SelectableList = ({ items, selectedItems, setSelectedItems, rows = 3, className = null }) => {
    const { t } = useB2BTranslation('b2b-common');
    const [isFieldVisible, setIsFieldVisible] = useState(false);
    const [allSelected, setAllSelected] = useState(false);

    useEffect(() => {
        setAllSelected(selectedItems.length === items.length);
    }, [selectedItems, items]);

    const handleToggle = (value) => {
        setSelectedItems(prev => {
            const newSelected = prev.includes(value)
                ? prev.filter(v => v !== value)
                : [...prev, value];
            return newSelected.sort((a, b) => a - b);
        });
    };

    const handleSelectUnselectAll = () => {
        if (allSelected) {
            setSelectedItems([]);
        } else {
            setSelectedItems(items.map(item => item.value));
        }
        setAllSelected(!allSelected);
    };

    const valueToLabelMap = items.reduce((acc, item) => {
        acc[item.value] = item.label;
        return acc;
    }, {});

    const selectedItemsLabels = selectedItems.map(value => valueToLabelMap[value]);
    const columns = Math.ceil(items.length / rows);

    return (
        <div className={generateClassName('selectable-list', '-container', className)}>
            <div className='selectable-list-items-selected'>
                {selectedItemsLabels.length ?
                    selectedItemsLabels.map(label => <div className="list-item-label" key={label}>{label}</div>) :
                    <div className="list-item-label">{t('All')}</div>
                }
                <IconButton onClick={() => setIsFieldVisible(!isFieldVisible)} className='selectable-list-expand-button'>
                    {isFieldVisible ? <ExpandLess /> : <ExpandMore />}
                </IconButton>
            </div>
            {isFieldVisible && (
                <div className='selectable-list-field'>
                    <IconButton onClick={handleSelectUnselectAll} className='selectable-list-select-all-or-none'>
                        {allSelected ? <RemoveDone /> : <DoneAll />}
                    </IconButton>
                    <Grid container spacing={2}>
                        {items.map((item) => (
                            <Grid item key={item.value} xs={12 / columns}>
                                <div className="selectable-list-item" onClick={() => handleToggle(item.value)}>
                                    <IconButton>
                                        {selectedItems.includes(item.value) ? <CheckBox /> : <CheckBoxOutlineBlank />}
                                    </IconButton>
                                    <span>{item.label}</span>
                                </div>
                            </Grid>
                        ))}
                    </Grid>
                </div>
            )}
        </div>
    );
};

SelectableList.propTypes = {
    selectorFieldName: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
        })
    ).isRequired,
    selectedItems: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ).isRequired,
    setSelectedItems: PropTypes.func.isRequired,
    className: PropTypes.string
};

export default SelectableList;